import { Vector3 } from 'three';

export const convertLatLongToCartesian = (latitude: number, longitude: number) => {
  const rho = 1; // earth radius is 1 unit in LAB
  const phi = Math.PI / 2 - (latitude * Math.PI) / 180;
  const theta = (longitude * Math.PI) / 180;

  return new Vector3().setFromSphericalCoords(rho, phi, theta);
};
